/* eslint-disable */
export default {
	quickEntry: 'Quick Entry',
	process: 'Common Processes',
	system: 'Systems',
	workbench: 'Personal Workspace',
	announcement: 'Policy Announcement',
	advisory: 'Consulting Services',
	acceptance: 'Request Handling',
	priceQuery: 'Price Library Query',
	inquiryQuery: 'Query RFQ',
	decisionQuery: 'Decision Query',
	quotationQuery: 'Manual Quotation Query',
	contractSystem: 'Contract System',
	paymentSystem: 'Payment System',
	noPending: 'No document for approval',
	networkManual: 'Network Collaboration Guidelines',
	systemManual: 'System User Manual for the Purchase System',
	doubtText: 'If you have any IT questions, call',
	ITText: 'Finance IT (87000)',
	wxText: 'If you have any questions about financial matters, you can also contact us via WeCom.',
	financial: 'Finance Hotline - Financial Consulting',
	orderQuery: 'Order Query',
	search_title: '查询条件',
	material_code: '物料编码',
	material_explain: '物料说明',
	please_enter: '请输入内容',
	material_category: '物料类别',
	open_range: '开放范围',
	brand: '品牌',
	model: '型号',
	please_choose: '请选择',
	internal_model: '内部型号',
	manufacturers_model: '厂商机型',
	auto_order: '自动下订单',
	yes: '是',
	no: '否',
	search: '查询',
	open: '开放',
	only_buy: '仅采购',
	close: '关闭',
	all: '全部',
	search_results: '查询结果',
	export: '导出',
	import: '导入',
	add: '新增',
	empty_data: '暂无数据',
	currency: '币种',
	reference_price: '参考价格',
	physical_management: '实物管理方式',
	whether_assets: '是否资产',
	operation: '操作',
	modify: '修改',
	source_code: '源物料编码',
	source_material_description: '源物料名称',
	replacement_material_code: '替换物料编码',
	replacement_item_description: '替换物料名称',
	replace_type: '替换类型',
	begin_time: '开始时间',
	end_time: '结束时间',
	remove: '删除',
	back_to_modify: '返回修改',
	confirm_import: '确认导入',
	cancel: '取消',
	confirm: '确定',
	prompt: '提示',
	it_may_take_a_long_time_to_export: '导出可能需要较长时间，请等待。（不要关闭页面或重复点击导出按钮）',
	id: 'ID',
	Product_name: '品名',
	unit: '单位',
	material_description: '物料描述',
	reference_unit_price: '参考单价',
	choose_country_and_region: '可选国家地区',
	MOQ: '起订量',
	volume: '体积',
	weight: '重量',
	new_reason: '新增原因',
	check_result: '校验结果',
	choose_file: '选择文件',
	already_choose: '已选择',
	no_choose: '未选择',
	material_name: '物料名称',
	reference_price_currency: '参考价格币种',
	allow_replacement: '允许替换',
	volume_cubic_meter: '体积(立方米)',
	weight_kg: '重量(千克)',
	message: '备注',
	updating_files: '附件上传',
	update: '上传',
	abstract_type: '抽象类型',
	material_source: '物料来源',
	default_accounting_account: '默认核算科目',
	default_asset_classification: '默认资产分类',
	whether_to_synchronize_the_rock: '是否同步磐石',
	product_source: '产品来源',
	manufacturer_model: '厂商机型',
	life_cycle_stage: '生命周期阶段',
	whether_in_kind: '是否实物送货',
	acceptance_nature: '验收性质',
	acceptance_tolerance: '验收允差',
	belonging_to_BG: '所属BG',
	submit: '提交',
	clean: '清空'
};
